module.exports = __webpack_public_path__ + "img/tuts-rating-slider-desktop-3.63b4f862.png";